import React, { useEffect, useState } from 'react';
import { useNavigationContext } from '../context/NavigationContext';
import { SectionIDs } from '../data/Sections';

export default function DeepLinkController(): JSX.Element
{
  const { moveToTheSection, activeSectionID } = useNavigationContext();
  // this prevents setting the hash before reading it
  const [ deeplinked, setDeeplinked ] = useState(false);

  useEffect(() =>
  {
    const id = window.location.hash.substr(1);
    moveToTheSection(id.length ? id : SectionIDs.Title);
    setDeeplinked(true);
  }, [ moveToTheSection ]);

  useEffect(() =>
  {
    if (!deeplinked) return;
    window.location.hash = '#' + activeSectionID;
  }, [ deeplinked, activeSectionID ]);

  return <></>;
}